'use client';

import React from 'react';
import styles from './HeroSection.module.scss';

import { useInView } from 'react-intersection-observer';
import createAnimationArr from '@/src/lib/helpers/createAnimationArr';
import Wrapper from '@/src/components/ui/wrapper/Wrapper';
import NextImage from "@/src/components/ui/nextImage/NextImage";

const heading = '5 Unique Hero Sections';
const excerpt =
    'Choose from five uniquely designed hero layouts to instantly tailor your storefront’s first impression.';

const HeroSection = () => {

    const { ref: inViewRef2, inView: inView2 } = useInView({
        triggerOnce: true,
        rootMargin: '-250px 0px 0px',
        threshold: 0,
    });

    return (
        <section className={styles.heroSection}>
            <Wrapper>
                <div className={styles.heroSection__head} ref={inViewRef2}>
                    <h2 className={`heading__2 ${styles.heading} ${inView2 && styles.animate__heading}`}>
                        {createAnimationArr(heading, styles.word__wrapper, 0, 0.01)}
                    </h2>
                    <p className={`excerpt ${styles.excerpt} ${inView2 && styles.animate__excerpt}`}>
                        {createAnimationArr(excerpt, styles.word__wrapper, 0.1, 0.01)}
                    </p>
                </div>

                <div className={styles.heroSection__list}>
                    <div className={styles.heroSection__item}>
                        <div className={styles.heroSection__pic}>
                            <img loading="lazy"
                                 srcSet="/images/themes/prompt/hero-sections/pic-1.webp 1x, /images/themes/prompt/hero-sections/pic-1@2x.webp 2x"
                                 src="/images/themes/prompt/hero-sections/pic-1.webp"/>
                        </div>
                        <div className={styles.heroSection__about}>
                            <h3 className={styles.heroSection__title}>Feature Focus Hero Carousel</h3>
                            <div className={styles.heroSection__desc}>Split-screen hero carousel combining text and image sections with gentle pastel highlights, helping users focus on your message while enhancing visual appeal.</div>
                        </div>
                    </div>
                    <div className={styles.heroSection__item}>
                        <div className={styles.heroSection__pic}>
                            <img loading="lazy"
                                 srcSet="/images/themes/prompt/hero-sections/pic-2.webp 1x, /images/themes/prompt/hero-sections/pic-2@2x.webp 2x"
                                 src="/images/themes/prompt/hero-sections/pic-2.webp"/>
                        </div>
                        <div className={styles.heroSection__about}>
                            <h3 className={styles.heroSection__title}>Offer Spotlight Hero</h3>
                            <div className={styles.heroSection__desc}>Promotional hero section with large text, visually framed product images, and a clear call-to-action to showcase deals effectively.</div>
                        </div>
                    </div>
                    <div className={styles.heroSection__item}>
                        <div className={styles.heroSection__pic}>
                            <img loading="lazy"
                                 srcSet="/images/themes/prompt/hero-sections/pic-3.webp 1x, /images/themes/prompt/hero-sections/pic-3@2x.webp 2x"
                                 src="/images/themes/prompt/hero-sections/pic-3.webp"/>
                        </div>
                        <div className={styles.heroSection__about}>
                            <h3 className={styles.heroSection__title}>Fanned Visual Hero</h3>
                            <div className={styles.heroSection__desc}>Break away from traditional sliders — this hero displays images in a fanned format, adding movement and intrigue while keeping the layout clean.</div>
                        </div>
                    </div>
                    <div className={styles.heroSection__item}>
                        <div className={styles.heroSection__pic}>
                            <img loading="lazy"
                                 srcSet="/images/themes/prompt/hero-sections/pic-4.webp 1x, /images/themes/prompt/hero-sections/pic-4@2x.webp 2x"
                                 src="/images/themes/prompt/hero-sections/pic-4.webp"/>
                        </div>
                        <div className={styles.heroSection__about}>
                            <h3 className={styles.heroSection__title}>Editorial Split Hero</h3>
                            <div className={styles.heroSection__desc}>Turn your hero into a story. Split screens, floating product cards, and layered visuals come together to showcase your products in a premium, engaging way.</div>
                        </div>
                    </div>
                    <div className={styles.heroSection__item}>
                        <div className={styles.heroSection__pic}>
                            <img loading="lazy"
                                 srcSet="/images/themes/prompt/hero-sections/pic-5.webp 1x, /images/themes/prompt/hero-sections/pic-5@2x.webp 2x"
                                 src="/images/themes/prompt/hero-sections/pic-5.webp"/>
                        </div>
                        <div className={styles.heroSection__about}>
                            <h3 className={styles.heroSection__title}>Hero with Search Bar</h3>
                            <div className={styles.heroSection__desc}>Hero section with a prominent search bar and full-width background, guiding shoppers to find products quickly and effortlessly.</div>
                        </div>
                    </div>
                </div>
            </Wrapper>
        </section>
    );
};

export default HeroSection;
